import { IconButton, Input } from "@commonsku/styles";
import React, { useRef, useState } from "react";
import { createAddItemColor, createAddItemSize } from "../../../actions";
import { useDispatch } from "react-redux";

interface NewVariantInputProps {
  inputType: "COLOR" | "SIZE";
  item_id: string;
}
const NewVariantInput = ({ inputType, item_id }: NewVariantInputProps) => {
  const dispatch = useDispatch();
  const [isTyping, setIsTyping] = useState<boolean>(false);
  const [newValue, setNewValue] = useState<string>("");
  const containerRef = useRef<HTMLDivElement>(null);

  const handleAddNewVariantOption = () => {
    const trimmedNewValue = newValue.trim();
    if (!trimmedNewValue) {
      return;
    }
    if (inputType === "COLOR") {
      dispatch(createAddItemColor(item_id, null, trimmedNewValue));
      setIsTyping(false);
      setNewValue("");
    } else {
      dispatch(createAddItemSize(item_id, null, trimmedNewValue));
      setIsTyping(false);
      setNewValue("");
    }
  };

  const handleInputFocusLost = (e: React.FocusEvent<HTMLDivElement>) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(e.relatedTarget) &&
      !newValue
    ) {
      setIsTyping(false);
    }
  };

  return !isTyping ? (
    <IconButton
      onClick={() => setIsTyping(true)}
      variant="text"
      style={{
        marginBottom: 0,
        width: 204,
        textAlign: "left",
      }}
    >
      {inputType === "COLOR" ? "Add a new Color" : "Add a new Size"}
    </IconButton>
  ) : (
    <div
      style={{
        width: 184,
        marginBottom: 0,
        display: "flex",
        flexDirection: "row",
      }}
      ref={containerRef}
    >
      <Input
        name="externalSkuInput"
        value={newValue}
        style={{
          marginBottom: 0,
          borderRadius: "5px",
        }}
        onChange={(e) => setNewValue(e.target.value)}
        onBlur={handleInputFocusLost}
        placeholder={inputType === "COLOR" ? "New Color" : "New Size"}
      />
      <IconButton
        onClick={handleAddNewVariantOption}
        variant="text"
        style={{
          marginBottom: 0,
          textAlign: "left",
        }}
        size="tiny"
      >
        Save
      </IconButton>
    </div>
  );
};

export default NewVariantInput;
